// import React from 'react';
// import { Breadcrumbs, Link, Typography, makeStyles } from '@material-ui/core';
// import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';

// const useStyles = makeStyles((theme) => ({
//     root: {
//         marginBottom: theme.spacing(2),
//         padding: theme.spacing(1),
//         backgroundColor: theme.palette.background.paper,
//         borderRadius: theme.shape.borderRadius,
//     },
//     breadcrumbItem: {
//         display: 'flex',
//         alignItems: 'center',
//         color: theme.palette.text.primary,
//         textDecoration: 'none',
//         '&:hover': {
//             color: theme.palette.primary.main,
//             textDecoration: 'underline',
//         },
//     },
//     breadcrumbIcon: {
//         marginRight: theme.spacing(0.5),
//     },
//     current: {
//         color: theme.palette.text.secondary,
//     },
// }));

// const CustomBreadcrumbs = ({ links, current }) => {
//     const classes = useStyles();

//     return (
//         <Breadcrumbs
//             className={classes.root}
//             aria-label="breadcrumb"
//             separator={<DoubleArrowIcon className={classes.breadcrumbIcon} fontSize="small" />}
//         >
//             {links.map((link, index) => (
//                 <Link
//                     key={index}
//                     color="inherit"
//                     href={link.href}
//                     className={classes.breadcrumbItem}
//                 >
//                     {link.label}
//                 </Link>
//             ))}
//             <Typography className={`${classes.breadcrumbItem} ${classes.current}`} color="textPrimary">
//                 {current}
//             </Typography>
//         </Breadcrumbs>
//     );
// };

// export default CustomBreadcrumbs;


import React from 'react';
import { Breadcrumbs, Link, Typography, makeStyles, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: "#cfd6e1",
        borderRadius: theme.shape.borderRadius,
    },
    breadcrumbItem: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.primary,
        textDecoration: 'none',
        fontSize: 'clamp(1rem, 1.5vw, 1.2rem)', // Responsive font size with clamp
        '&:hover': {
            color: theme.palette.primary.main,
            textDecoration: 'underline',
        },
    },
    breadcrumbIcon: {
        marginRight: theme.spacing(0.5),
    },
    current: {
        color: theme.palette.text.secondary,
    },
}));

const CustomBreadcrumbs = ({ links, current }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    // Determine which links to show based on screen size
    const visibleLinks = isMobile ? links.slice(-1) : links;

    return (
        <Breadcrumbs
            className={classes.root}
            aria-label="breadcrumb"
            separator={<DoubleArrowIcon className={classes.breadcrumbIcon} fontSize="small" />}
        >
            {visibleLinks.map((link, index) => (
                <Link
                    key={index}
                    color="inherit"
                    href={link.href}
                    className={classes.breadcrumbItem}
                >
                    {link.label}
                </Link>
            ))}
            <Typography className={`${classes.breadcrumbItem} ${classes.current}`} color="textPrimary">
                {current}
            </Typography>
        </Breadcrumbs>
    );
};

export default CustomBreadcrumbs;
